/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIStorageArticleAutocompleteSuggestion
 */
export interface APIStorageArticleAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleAutocompleteSuggestion
     */
    articleName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleAutocompleteSuggestion
     */
    articleNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleAutocompleteSuggestion
     */
    positionName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleAutocompleteSuggestion
     */
    amount?: number;
}

/**
 * Check if a given object implements the APIStorageArticleAutocompleteSuggestion interface.
 */
export function instanceOfAPIStorageArticleAutocompleteSuggestion(value: object): value is APIStorageArticleAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIStorageArticleAutocompleteSuggestionFromJSON(json: any): APIStorageArticleAutocompleteSuggestion {
    return APIStorageArticleAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIStorageArticleAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStorageArticleAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'articleName': json['article_name'] == null ? undefined : json['article_name'],
        'articleNumber': json['article_number'] == null ? undefined : json['article_number'],
        'positionName': json['position_name'] == null ? undefined : json['position_name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function APIStorageArticleAutocompleteSuggestionToJSON(value?: APIStorageArticleAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'article_name': value['articleName'],
        'article_number': value['articleNumber'],
        'position_name': value['positionName'],
        'amount': value['amount'],
    };
}

